import { RaffleStatus } from 'src/@types/raffles';

export const RAFFLE_STATUS = [
  { label: 'Pending', value: RaffleStatus.PENDING },
  { label: 'Upcoming', value: RaffleStatus.UPCOMING },
  { label: 'Active', value: RaffleStatus.ACTIVE },
  { label: 'Completed', value: RaffleStatus.COMPLETED },
];
